import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExpenseCategoryService {


  constructor(private http: HttpClient) { }
  
  url = environment.serverAPI5 + "/api"; 

 

  getAllUnitsDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/posexpensecategory/dropdown`);
  }


  getexpense(id: number): Observable<Object> {
    return this.http.get(`${this.url}/posexpensecategory${id}`);
  }

  addOrEditexpense(posexpensecategory: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}/posexpensecategory`, posexpensecategory)
	}

  getAllExpense(Page: number, size: number, sort): Observable<Object> {
    return this.http.get(`${this.url}/posexpensecategory?page=${Page}&size=${size}&sort=${sort}`);
	}

  ExpenseSearch(query, Page: any, size: any, sort: any): Observable<Object> {

		return this.http.get(`${this.url}/posexpensecategory/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
	}
  deleteByExpensecategoryId(id: any): Observable<Object> {
		return this.http.delete(`${this.url}/posexpensecategory/${id}`);
	}
  downloadExpenseCategoryTemplate(): Observable<any> {
    return this.http.get(`${this.url}/posexpensecategory/template/download`, {responseType: 'arraybuffer',observe: 'response' });
  }
  downloadExpenseCategoryReport(Page: number, size: number, sort,selectionExpensesCategory): Observable<any> {
		return this.http.post(`${this.url}/posexpensecategory/export/page?page=${Page}
		&size=${size}&sort=${sort}`, selectionExpensesCategory, { 
		  responseType: 'arraybuffer',
		  observe: 'response'
		});
	  }

}

